import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {StudentAnnualReport} from 'APIs/letrusAPI/studentAnnualReport/types';
import {Tag} from 'letrus-ui';
import styles from './GeneralAnalysisCard.module.scss';
import CompetenceCard from '../CompetenceCard';

interface GeneralAnalysisCardProps {
  annualReport: StudentAnnualReport | null;
  selectedCompetenceInfo: string;
  view: string;
}

function GeneralAnalysisCard({
  annualReport,
  selectedCompetenceInfo,
  view,
}: GeneralAnalysisCardProps) {
  const percentageChange = annualReport?.percentage_change ?? 0;

  return (
    <article
      className={styles.container}
      aria-labelledby="general-analysis-title"
    >
      <header className={styles.header}>
        <div className={styles.titleContainer}>
          <h2 id="general-analysis-title" className={styles.title}>
            Análise Geral
          </h2>

          {view === 'competence' && (
            <Tag
              variant="readOnly"
              backgroundColor="#e8f2fc"
              mainColor="#1d79e6"
              text={selectedCompetenceInfo}
            />
          )}
        </div>

        <time
          className={styles.dateRange}
          dateTime={`${new Date().getFullYear()}-01-01/${
            new Date().toISOString().split('T')[0]
          }`}
        >
          {`01/01/${new Date().getFullYear()} até ${new Date().toLocaleDateString(
            'pt-BR',
          )}`}
        </time>
      </header>

      <div className={styles.totalEvolution} aria-label="Evolução Total">
        <p className={styles.evolutionLabel}>Evolução Total</p>
        <p
          className={`${styles.evolutionScore} ${
            percentageChange < 0 ? styles.negativeScore : ''
          }`}
          aria-live="polite"
        >
          <strong>
            {percentageChange >= 0
              ? `+${percentageChange}%`
              : `${percentageChange}%`}
          </strong>{' '}
          (<span>{annualReport?.difference} pontos</span>)
        </p>

        <span
          className={`${styles.status} ${
            percentageChange < 0 ? styles.negativeStatus : ''
          }`}
        >
          <FontAwesomeIcon
            icon={percentageChange >= 0 ? 'arrow-up' : 'arrow-down'}
            size="sm"
          />{' '}
          {percentageChange >= 0 ? 'Melhora' : 'Queda'}
        </span>
      </div>

      <section
        aria-labelledby="competence-analysis-title"
        className={styles.competenceSection}
      >
        <h3 id="competence-analysis-title" className={styles.subtitle}>
          Análise por Competência
        </h3>

        <div className={styles.competenceList}>
          <CompetenceCard
            key={annualReport?.highest_competence?.label}
            status="positive"
            points={annualReport?.highest_competence?.points ?? 0}
            label={annualReport?.highest_competence?.label ?? ''}
            nickname={annualReport?.highest_competence?.nickname ?? ''}
          />

          <CompetenceCard
            key={annualReport?.lowest_competence?.label}
            status="negative"
            points={annualReport?.lowest_competence?.points ?? 0}
            label={annualReport?.lowest_competence?.label ?? ''}
            nickname={annualReport?.lowest_competence?.nickname ?? ''}
          />
        </div>
      </section>
    </article>
  );
}

export default GeneralAnalysisCard;
